<script>
    import { onMount } from 'svelte';
    import { film } from './store.js';
    import { prevent_default } from 'svelte/internal';
    import { navigate } from 'svelte-routing';
  
    let links = [];
    let title = '';
    let selectedLink = '';
  
    onMount(async () => {
      if ($film.title === undefined || $film.links === undefined) {
        navigate('/');
        return;
      }
      links = $film.links;
      title = $film.title;
      selectedLink = links[0].url;
    });
  
    function selectLink(url) {
      selectedLink = url;
    }

  </script>
<h1>{title}</h1> 
<div class="buttons">
    
    {#each links as link, index}
        <button on:click={() => selectLink(link.url)}>Link {index + 1}</button>
    {/each}
</div>

<iframe title="video" src={selectedLink} allowfullscreen></iframe>


<style>
    h1 {
        text-align: center;
    }
    .buttons {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }

    button {
        margin: 0.5rem;
        padding: 0.5rem 1rem;
        cursor: pointer;
    }
  
    iframe {
        width: 100%;
        height: 80vh;
    }
</style>